import * as tslib_1 from "tslib";
import React from 'react';
import { compose } from 'redux';
import classnames from 'classnames';
import { Trans, withTranslation } from 'react-i18next';
import Button from '../Button';
import Popup from '../Popup';
import TagsPopup from '../TagsPopup';
import ScrollableContent from '../ScrollableContent';
import ConfirmationPopup from '../Popup/ConfirmationPopup';
import Checkbox from '../Checkbox2';
import { IconSize } from '../Icons/IconWrap';
import IconButton from '../Button/IconButton';
import IconArrowDown from '../Icons/ArrowDown';
import IconClock from '../Icons/Clock';
import IconTrashcan from '../Icons/Trashcan';
import IconChange from '../Icons/Change';
import { EditorFlavourConfigs } from '../DaEditorWrapper/config';
import DaEditorWrapper from '../DaEditorWrapper/LoadableDaEditorWrapper';
import { getFeature } from '../DaEditorWrapper/Features';
import { WORD_COUNT_FEATURE } from '../DaEditorWrapper/Features/wordCount';
import { IS_EMPTY_FEATURE } from '../DaEditorWrapper/Features/isEmpty';
import reduxConnectContainer from './WriterPopup.container';
import { READING_SPEED } from './constants';
import { hasChanged } from '../DaEditorWrapper/utils';
import { WriterPopupType } from './types';
import Timestamp from '../Timestamp';
import CoverImage from './CoverImage';
import { FIRST_IMAGE_FEATURE } from '../DaEditorWrapper/Features/firstImage';
import get from 'lodash/get';
import LoadingIndicator from '../LoadingIndicator';
import mergeTheme from '../DaEditorWrapper/Themes/mergeTheme';
// Merge the text theme with the editor theme (content vs editor toolbars etc)
import textTheme from '../DaEditorWrapper/Themes/Viewer/journal.scss';
import editorTheme from '../DaEditorWrapper/Themes/Editor/journal.scss';
var journalTheme = mergeTheme(textTheme, editorTheme);
import s from './WriterPopup.scss';
// Disable tags popup for v1
var TAGS_POPUP_ENABLED = false;
var defaultProps = {
    type: WriterPopupType.JOURNAL,
};
var defaultState = {
    canSubmit: false,
    hasUnsavedChanges: false,
    charactersEntered: 0,
    isEditorEmpty: true,
    isFeaturedPost: false,
    isPublished: false,
    journalTitle: '',
    deviationId: undefined,
    lastSavedAt: '',
    readingTime: 0,
    saveLocation: '',
    showDiscardChangesPopup: false,
    showSwitchToStatusPopup: false,
    showTagsPopup: false,
    coverImage: undefined,
    coverImageManuallySet: false,
    savingDraft: false,
    publishing: false,
    editorApi: null,
};
var enhance = compose(reduxConnectContainer, withTranslation());
var WriterPopup = /** @class */ (function (_super) {
    tslib_1.__extends(WriterPopup, _super);
    function WriterPopup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = tslib_1.__assign({}, defaultState, { hasUnsavedChanges: !!_this.props.hasUnsavedChanges, isFeaturedPost: !!_this.props.isFeatured });
        _this.handleClose = function () {
            if (_this.state.hasUnsavedChanges) {
                _this.showDiscardChangesPopup();
            }
            else {
                _this.props.onClose();
                _this.props.writerPopupClosed();
            }
        };
        _this.handleSave = function () {
            var type = _this.props.type;
            var _a = _this.state, _b = _a.journalTitle, title = _b === void 0 ? '' : _b, deviationId = _a.deviationId;
            var editorContent = _this.editorContent;
            var editorRawState = _this.editorRawState;
            var features = _this.editorFeatures;
            _this.setState({ savingDraft: true, publishing: false });
            _this.props.saveWriterDeviation({
                type: type,
                title: title,
                deviationId: deviationId,
                editorContent: editorContent,
                editorRawState: editorRawState,
                editorFeatures: features,
                coverImageDeviationId: _this.getCoverImageDeviationId(),
            });
        };
        _this.handleSubmit = function () {
            var _a = _this.props, type = _a.type, groupId = _a.groupId;
            var _b = _this.state, _c = _b.journalTitle, title = _c === void 0 ? '' : _c, deviationId = _b.deviationId, featured = _b.isFeaturedPost;
            var editorContent = _this.editorContent;
            var editorRawState = _this.editorRawState;
            var features = _this.editorFeatures;
            // Publishing a journal would simply require a deviationId and
            // featured props, but we send the whole journal payload in case we
            // need to create the draft first
            _this.setState({ savingDraft: false, publishing: true });
            _this.props.publishWriterDeviation({
                type: type,
                title: title,
                deviationId: deviationId,
                featured: featured,
                editorContent: editorContent,
                editorRawState: editorRawState,
                editorFeatures: features,
                groupId: groupId,
                coverImageDeviationId: _this.getCoverImageDeviationId(),
            });
        };
        _this.handleInitialContent = function (contentState, raw) {
            _this.initialContentState = contentState;
            _this.initialRawState = raw;
        };
        _this.handleEditorChange = function (rawContentState, editorContent, featuresData) {
            _this.editorRawState = rawContentState;
            _this.editorContent = editorContent;
            _this.editorFeatures = featuresData;
            if (_this.initialContentState &&
                hasChanged(_this.initialContentState, _this.initialRawState, editorContent, rawContentState)) {
                _this.setState({
                    hasUnsavedChanges: true,
                    canSubmit: _this.state.journalTitle !== '',
                });
            }
            else {
                _this.setState({
                    hasUnsavedChanges: !!_this.props.hasUnsavedChanges,
                    canSubmit: _this.state.journalTitle !== '' && !_this.state.isEditorEmpty,
                });
            }
            _this.handleEditorFeatureChange(featuresData);
        };
        _this.handleEditorFeatureChange = function (features) {
            var newState = {};
            for (var _i = 0, features_1 = features; _i < features_1.length; _i++) {
                var feature = features_1[_i];
                switch (feature.type) {
                    case WORD_COUNT_FEATURE:
                        var charactersEntered = feature.data.chars;
                        var readingTime = Math.round(feature.data.words / READING_SPEED);
                        newState = tslib_1.__assign({}, newState, { charactersEntered: charactersEntered,
                            readingTime: readingTime });
                        break;
                    case IS_EMPTY_FEATURE:
                        newState = tslib_1.__assign({}, newState, { isEditorEmpty: feature.data.isEmpty });
                        break;
                    default:
                        break;
                }
            }
            _this.setState(newState);
        };
        _this.handleDiscardChanges = function () {
            _this.setState({
                showDiscardChangesPopup: false,
            }, _this.props.onClose);
        };
        _this.handleCancelConfirmation = function () {
            _this.setState({
                showDiscardChangesPopup: false,
                showSwitchToStatusPopup: false,
            });
        };
        _this.handleSwitchToStatusUpdateMode = function () {
            if (_this.state.hasUnsavedChanges) {
                _this.setState({ showSwitchToStatusPopup: true });
            }
            else {
                _this.switchToStatusUpdate();
            }
        };
        _this.switchToStatusUpdate = function () {
            var _a = _this.state, editorApi = _a.editorApi, hasUnsavedChanges = _a.hasUnsavedChanges;
            _this.props.onSwitchMode &&
                _this.props.onSwitchMode(_this.editorRawState, _this.editorContent, _this.editorFeatures, hasUnsavedChanges, editorApi && editorApi.getCurrentSelection().toJSON());
        };
        _this.handleEditorReady = function (toolbars, api) {
            _this.setState({
                editorApi: api,
            });
        };
        _this.handleTitleChange = function (e) {
            var cleaned = e.target.value.replace(/(\r\n|\n|\r)/gm, '');
            _this.setState({
                journalTitle: cleaned,
                canSubmit: !_this.state.isEditorEmpty && cleaned !== '',
            });
        };
        _this.handleCoverImageChange = function (deviation) {
            _this.setState({ coverImage: deviation, coverImageManuallySet: true });
        };
        _this.showTagsPopup = function () {
            _this.setState({
                showTagsPopup: true,
            });
        };
        _this.handleSubmitTagsPopup = function (payload) {
            //TODO
            _this.handleCloseTagsPopup();
        };
        _this.handleCloseTagsPopup = function () {
            _this.setState({
                showTagsPopup: false,
            });
        };
        _this.showDiscardChangesPopup = function () {
            _this.setState({
                showDiscardChangesPopup: true,
            });
        };
        _this.getIsLiterature = function () {
            return _this.props.type === WriterPopupType.LITERATURE;
        };
        _this.getIsGroupPost = function () {
            return _this.props.groupId !== undefined;
        };
        _this.toggleFeaturedPost = function () {
            return _this.setState({ isFeaturedPost: !_this.state.isFeaturedPost });
        };
        _this.getCoverImageDeviationId = function () {
            var deviation = _this.props.deviation;
            var _a = _this.state, coverImage = _a.coverImage, coverImageManuallySet = _a.coverImageManuallySet;
            var chosenCoverImage = coverImageManuallySet
                ? coverImage
                : deviation && deviation.coverImage;
            return chosenCoverImage && chosenCoverImage.deviationId;
        };
        return _this;
    }
    WriterPopup.getDerivedStateFromProps = function (props, state) {
        var deviation = props.deviation, _a = props.hasUnsavedChanges, hasUnsavedChanges = _a === void 0 ? false : _a;
        if (deviation && deviation.deviationId !== state.deviationId) {
            return tslib_1.__assign({ hasUnsavedChanges: hasUnsavedChanges, isPublished: deviation.isPublished, lastSavedAt: deviation.publishedTime, journalTitle: deviation.title, deviationId: deviation.deviationId, coverImage: deviation.coverImage, coverImageManuallySet: false, canSubmit: true }, WriterPopup.migrateLegacyCoverImageJournal(props, state));
        }
        return null;
    };
    /**
     * This is the auto-migration of legacy journals that used first image
     * feature for the cover.
     *
     * Logic is to peek the features for the first image feature then use
     * that deviation as is the user has manually selected it.
     *
     */
    WriterPopup.migrateLegacyCoverImageJournal = function (props, state) {
        var type = props.type, deviation = props.deviation, editorInitState = props.editorInitState;
        var coverImageManuallySet = state.coverImageManuallySet, deviationId = state.deviationId;
        if ((deviation && deviation.deviationId === deviationId) || !deviation) {
            return {};
        }
        var isJournal = type === WriterPopupType.JOURNAL;
        var initialContent = (deviation && deviation.textContent) || editorInitState;
        if (isJournal &&
            initialContent &&
            !coverImageManuallySet &&
            !deviation.coverImage) {
            var initFeatures = get(initialContent, 'html.features');
            if (initFeatures && initFeatures.match(/"FIRST_IMAGE_FEATURE"/)) {
                try {
                    var first = getFeature(FIRST_IMAGE_FEATURE, initFeatures);
                    if (first && first.data && first.data.deviation) {
                        return {
                            coverImage: first.data.deviation,
                            coverImageManuallySet: true,
                        };
                    }
                }
                catch (e) {
                    // Nothing we can do
                }
            }
        }
        return {};
    };
    WriterPopup.prototype.componentWillUnmount = function () {
        var resetWriterPopup = this.props.resetWriterPopup;
        resetWriterPopup && resetWriterPopup();
    };
    WriterPopup.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            this.renderWriterPopup(),
            this.renderDiscardChangesPopup(),
            this.renderSwitchToStatusPopup(),
            this.renderTagsPopup()));
    };
    WriterPopup.prototype.renderWriterPopup = function () {
        var className = this.props.className;
        return (React.createElement(Popup, { isOpen: true, className: classnames(s['root'], s['feature-journal-cover-image'], className), withCloseButton: true, closeBtnClassName: s['close-btn'], onRequestClose: this.handleClose },
            this.renderHeader(),
            this.renderWriterControls(),
            this.renderBody()));
    };
    WriterPopup.prototype.renderHeader = function () {
        var _a = this.props, t = _a.t, headerTitle = _a.headerTitle;
        var isLiterature = this.getIsLiterature();
        var canSwitchToDifferentMode = this.props.onSwitchMode && !this.state.isPublished && !isLiterature;
        return (React.createElement("div", { className: s['header'] },
            React.createElement("div", { className: s['popup-title'] },
                headerTitle && headerTitle,
                !headerTitle &&
                    t(isLiterature ? 'writer.submitLiterature' : 'writer.submitJournal')),
            canSwitchToDifferentMode && (React.createElement("div", { className: s['mode-switcher'] },
                React.createElement(Trans, { i18nKey: "writer.switchToStatusUpdate" },
                    "Switch to",
                    ' ',
                    React.createElement("a", { onClick: this.handleSwitchToStatusUpdateMode }, "status update"))))));
    };
    WriterPopup.prototype.renderWriterControls = function () {
        var _a = this.props, error = _a.error, isSubmitting = _a.isSubmitting;
        var _b = this.state, canSubmit = _b.canSubmit, saveLocation = _b.saveLocation, lastSavedAt = _b.lastSavedAt, isPublished = _b.isPublished, savingDraft = _b.savingDraft, publishing = _b.publishing, journalTitle = _b.journalTitle;
        var status = this.props.t(isPublished ? 'writer.status.published' : 'writer.status.draft');
        var isJournal = !this.getIsLiterature();
        var isInvalid = !journalTitle;
        var canBeFeatured = !this.getIsLiterature() && !this.getIsGroupPost();
        var hasSaveStateInfo = isJournal && !this.getIsGroupPost();
        return (React.createElement("div", { className: s['journal-controls'] },
            React.createElement("div", { className: s['journal-info'] },
                React.createElement(Trans, { parent: "span", i18nKey: "writer.currentStatus" },
                    "Current Status: ",
                    React.createElement("strong", null, status)),
                isJournal && saveLocation && (React.createElement(Trans, { parent: "span", i18nKey: "writer.savedIn" },
                    "Saved in ",
                    React.createElement("strong", null, saveLocation))),
                hasSaveStateInfo &&
                    (lastSavedAt ? (React.createElement(Timestamp, { timestamp: lastSavedAt })) : (React.createElement(Trans, { parent: "span", i18nKey: "writer.notSaved" }, "Changes not saved"))),
                error && React.createElement("span", null, error)),
            React.createElement("div", { className: s['journal-actions'] },
                TAGS_POPUP_ENABLED && (React.createElement(IconButton, { onClick: this.showTagsPopup, noHoverEffect: true, className: s['journal-tags'] },
                    this.props.t('writer.tags'),
                    React.createElement(IconArrowDown, { className: s['alert-close'], size: IconSize.SMALL }))),
                canBeFeatured && (React.createElement("label", { className: classnames(isInvalid && s['disabled']) },
                    React.createElement(Checkbox, { isChecked: this.state.isFeaturedPost, onChange: this.toggleFeaturedPost, className: s['checkbox'], disabled: isInvalid }),
                    this.props.t('writer.featuredPost'))),
                !this.getIsLiterature() &&
                    !this.getIsGroupPost() &&
                    !this.state.isPublished && (React.createElement(Button, { view: "b2", type: "button", height: "medium", className: classnames(isInvalid && s['disabled']), onClick: this.handleSave, disabled: isInvalid }, isSubmitting && savingDraft
                    ? this.props.t('writer.status.saving')
                    : this.props.t('writer.saveAsDraft'))),
                React.createElement(Button, { className: classnames(!canSubmit && s['disabled']), type: "button", height: "medium", onClick: this.handleSubmit, disabled: !canSubmit }, isSubmitting && publishing
                    ? this.props.t('writer.status.publishing')
                    : this.props.t(this.state.isPublished ? 'writer.update' : 'writer.submit')))));
    };
    WriterPopup.prototype.renderBody = function () {
        return (React.createElement(ScrollableContent, { className: s['scrollable-content'] },
            this.renderTitleEditor(),
            this.renderContentEditor()));
    };
    WriterPopup.prototype.renderTitleEditor = function () {
        return this.getIsLiterature()
            ? this.renderLiteratureTitleEditor()
            : this.renderJournalTitleEditor();
    };
    WriterPopup.prototype.renderLiteratureTitleEditor = function () {
        return (React.createElement("div", { className: classnames(s['journal-title']) },
            React.createElement("div", { className: s['content'] }, this.renderTitle())));
    };
    WriterPopup.prototype.renderJournalTitleEditor = function () {
        var _a = this.props, deviation = _a.deviation, t = _a.t;
        var _b = this.state, coverImage = _b.coverImage, coverImageManuallySet = _b.coverImageManuallySet, readingTime = _b.readingTime;
        var coverDeviation = coverImageManuallySet
            ? coverImage
            : deviation && deviation.coverImage;
        return (React.createElement(CoverImage, { className: s['journal-title'], deviation: coverDeviation, onChange: this.handleCoverImageChange },
            React.createElement("div", { className: s['content'] },
                this.renderTitle(),
                React.createElement("div", { className: s['journal-readtime'] },
                    React.createElement(IconClock, { className: s['clock-icon'] }),
                    ' ',
                    t('writer.readingTime', { count: readingTime })))));
    };
    WriterPopup.prototype.renderTitle = function () {
        var journalTitle = this.state.journalTitle;
        var t = this.props.t;
        return (React.createElement("textarea", { className: s['title-textarea'], placeholder: t('writer.title.placeholder'), onChange: this.handleTitleChange, onKeyDown: function (e) {
                if (e.keyCode === 13) {
                    e.preventDefault();
                    return false;
                }
            }, maxLength: 50, defaultValue: journalTitle }));
    };
    WriterPopup.prototype.renderContentEditor = function () {
        var _a = this.props, deviation = _a.deviation, editorInitState = _a.editorInitState, selectionState = _a.selectionState;
        var initialContent = (deviation && deviation.textContent) || editorInitState;
        var flavour = this.getIsLiterature()
            ? EditorFlavourConfigs.LITERATURE
            : EditorFlavourConfigs.JOURNAL;
        return (React.createElement("div", { className: s['journal-content'] },
            React.createElement("div", { className: classnames(s['content'], 'da-editor-journal') },
                React.createElement(DaEditorWrapper, { loadingComponent: LoadingIndicator, flavour: flavour, autoFocus: true, editorKey: "journalBody", placeholder: this.props.t('writer.content.placeholder'), selectionState: selectionState, onContentChange: this.handleEditorChange, onEditorInit: this.handleEditorReady, onInitialContentReady: this.handleInitialContent, fixedParagraph: true, initialContent: initialContent, theme: journalTheme, filterPaste: true }))));
    };
    WriterPopup.prototype.renderDiscardChangesPopup = function () {
        return (this.state.showDiscardChangesPopup && (React.createElement(ConfirmationPopup, { isOpen: true, title: this.props.t('writer.confirm.discardChanges'), text: this.props.t('writer.confirm.discardChangesText'), confirmBtnType: "danger", confirmBtnLabel: this.props.t('popup.discard'), onCancel: this.handleCancelConfirmation, onConfirm: this.handleDiscardChanges, icon: React.createElement(IconTrashcan, { size: IconSize.HUGE }) })));
    };
    WriterPopup.prototype.renderSwitchToStatusPopup = function () {
        return (this.state.showSwitchToStatusPopup && (React.createElement(ConfirmationPopup, { isOpen: true, title: this.props.t('writer.switchToStatusUpdate.confirmation.title'), text: this.props.t('writer.switchToStatusUpdate.confirmation.text'), confirmBtnType: "dark", confirmBtnLabel: this.props.t('popup.confirm'), onCancel: this.handleCancelConfirmation, onConfirm: this.switchToStatusUpdate, icon: React.createElement(IconChange, { size: IconSize.HUGE }) })));
    };
    WriterPopup.prototype.renderTagsPopup = function () {
        return (TAGS_POPUP_ENABLED &&
            (this.state.showTagsPopup && (React.createElement(TagsPopup, { isOpen: true, onClose: this.handleCloseTagsPopup, onSubmit: this.handleSubmitTagsPopup }))));
    };
    WriterPopup.defaultProps = defaultProps;
    return WriterPopup;
}(React.Component));
export { WriterPopup };
export default enhance(WriterPopup);
//# sourceMappingURL=WriterPopup.js.map